import { gql } from '@apollo/client';

export const GET_SSI_BILLING_RULES = gql`
  query GetSsiBillingRules($ssiId: UUID!) {
    ssiBillingRules(ssiId: $ssiId) {
      studySiteInvestigatorId
      rulesText
      updatedAt
    }
  }
`;
